import {Component, Input, OnInit} from '@angular/core';
import {Warehouse, Warehouse4} from '../../../warehouse';
import {AbstractControl, FormBuilder, Validators} from '@angular/forms';
import {CintacValidators} from '../../../../_shared/cintac-validators';
import {WarehouseParamsFormService} from '../warehouse-params-form.service';

@Component({
    selector: 'app-warehouse4-params-form',
    templateUrl: './warehouse4-params-form.component.html',
    styleUrls: ['../../project-form.css']
})
export class Warehouse4ParamsFormComponent implements OnInit {

    @Input() warehouse: Warehouse4;
    warehouseData: AbstractControl;
    isChanged: boolean;
    supportConditions = Warehouse.getSupportConditions();
    inputFocus: string;

    formErrors: any;
    particularFormErrors = {
        'slope_1': '',
        'column_height': '',
        'width_1': '',
    };
    validationMessages: any;
    particularValidationMessages = {
        'slope_1': {
            'required': 'Ingresar pendiente de cubierta.',
            'pattern': CintacValidators.getSlopeValidatorMessage()
        },
        'column_height': {
            'required': 'Ingresar altura de hombro.',
            'pattern': CintacValidators.getPositiveIntegerValidatorMessage()
        },
        'width_1': {
            'required': 'Ingresar luz.',
            'pattern': CintacValidators.getPositiveIntegerValidatorMessage()
        },
        'total_length': {
            'required': 'Largo total debe ser multiplo de la Distancia entre Marcos.',
            'pattern': CintacValidators.getPositiveIntegerValidatorMessage()
        }
    };

    constructor(private fb: FormBuilder, private warehouseFormService: WarehouseParamsFormService) {
        this.formErrors = this.warehouseFormService.getCommonFormErrors();
        Object.assign(this.formErrors, this.particularFormErrors);
        this.validationMessages = this.warehouseFormService.getCommonFormValidationMessages();
        Object.assign(this.validationMessages, this.particularValidationMessages);
        this.warehouseData = this.fb.group({
            frame_distance: [null, [Validators.required, CintacValidators.positiveIntegerValidator()]],
            total_length: [null, [Validators.required, CintacValidators.positiveIntegerValidator()]],
            support_condition_left: [null, [Validators.required, CintacValidators.supportCondValidator]],
            support_condition_right: [null, [Validators.required, CintacValidators.supportCondValidator]],
            slope_1: [null, [Validators.required, CintacValidators.slopeValidator()]],
            column_height: [null, [Validators.required, CintacValidators.positiveIntegerValidator()]],
            width_1: [null, [Validators.required, CintacValidators.positiveIntegerValidator()]],
        });
    }

    ngOnInit() {
        this.warehouseFormService.initWarehouseDataForm(this.warehouseData, this.warehouse);
        this.warehouseData.patchValue({
            support_condition_right: this.warehouse.support_condition_right,
            slope_1: this.warehouse.slope_1,
            column_height: this.warehouse.column_height,
            width_1: this.warehouse.width_1,
        });
        this.warehouseData.valueChanges.subscribe(values => this.onValueChanged());
        this.isChanged = false;
    }

    private onValueChanged() {
        this.warehouseFormService.updateFormMessages(this.warehouseData, this.formErrors, this.validationMessages);
        if (this.warehouseData.value.total_length % this.warehouseData.value.frame_distance != 0) {
                this.formErrors.total_length = this.validationMessages.total_length.required;
            }
        this.updateWarehouse();
        this.isChanged = !this.isChanged;
    }

    updateWarehouse() {
        this.warehouseFormService.updateWarehouse(this.warehouse, this.warehouseData);
        this.warehouse.slope_1 = this.warehouseData.value.slope_1;
        this.warehouse.column_height = this.warehouseData.value.column_height;
        this.warehouse.width_1 = this.warehouseData.value.width_1;
    }

    changeFocus(input) {
        this.inputFocus = input;
    }
}



// WEBPACK FOOTER //
// ./src/app/project/project-form-components/warehouse-params-forms/warehouse4-params-form/warehouse4-params-form.component.ts